import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { reverseFormatDate } from '../../../../utils/dateFunctions';
import { DEFAULT_TABLE_ROWS_PER_PAGE } from '../../../../utils/formValidation/commonConstants';
import { stableSort } from '../../../../utils/sortFunctions';
import ResultsTable from '../../../table/ResultsTable';

import OccSummaryDataRow from './OccSummaryDataRow';

import app from '../../../../app.module.css';
import local from './occStyles.module.css';

const headCells = [
    { id: 'eventDate', numeric: false, label: 'Date', align: 'left' },
    { id: 'visits', numeric: true, label: 'Visits', align: 'center' },
    { id: 'group', numeric: false, label: 'Group', align: 'left' },
    { id: 'type', numeric: false, label: 'Type', align: 'left' }
];

const initialRowMetaData = {
    order: 'asc',
    orderBy: 'eventDate',
    page: 0,
    rowsPerPage: DEFAULT_TABLE_ROWS_PER_PAGE
};

const OccSummaryData = ({ currentParticipant }) => {
    // LOCAL STATE
    const [rows, setRows] = useState([]);
    const [rowMetaData, setRowMetaData] = useState(initialRowMetaData);

    // STORE STATE
    const occActivity = useSelector((state) => state.entities.participantService.occActivity);

    // USEEFFECTS
    useEffect(() => {
        setRows([]);
    }, []);

    useEffect(() => {
        if (occActivity?.length < 1 || occActivity[0].participantId !== currentParticipant.id)
            return;
        const rows = occActivity.map((el) => ({
            ...el,
            eventDate: reverseFormatDate(el.date),
            visits: el.visits || 'zz',
            group: el.group || 'zz',
            type: el.type || 'zz'
        }));

        setRows(rows);
    }, [occActivity]);

    // FNS
    const createRows = () =>
        stableSort(rows, rowMetaData.orderBy, rowMetaData.order).map((el) => (
            <OccSummaryDataRow key={el.id} row={el} />
        ));

    // RENDER
    return (
        <div className={local.occSummaryWrapper}>
            <div className={app.sectionHeading}>OCC Summary Data</div>
            {rows.length < 1 ? (
                <div>No summary data</div>
            ) : (
                <ResultsTable
                    defaultOrderBy={rowMetaData.orderBy}
                    sortOrder={rowMetaData.order}
                    headCells={headCells}
                    passRowMetaDataUp={setRowMetaData}
                    tableRows={createRows()}
                    totalResults={rows.length}
                />
            )}
        </div>
    );
};

OccSummaryData.propTypes = {
    currentParticipant: PropTypes.object
};

export default OccSummaryData;
